import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDialogRef } from '@angular/material/dialog';
import { UnderMaintenanceComponent } from './under-maintenance.component';


@NgModule({
  declarations: [
    UnderMaintenanceComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})
export class  UnderMaintenanceModule { }